import { createFileRoute } from '@tanstack/react-router'
import { CompanyChat } from '@/features/company-chat/chat'

export const Route = createFileRoute(
  '/_authenticated/company-chat/$conversationId/'
)({
  component: CompanyChat,
})
